/** Calendar month as YYYY-MM (local). */
export function currentYm(): string {
  const t = new Date()
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}`
}

/** Move by whole months from the first day of `ym`. */
export function bumpMonth(ym: string, delta: number): string {
  const [y, m] = ym.split('-').map(Number)
  const d = new Date(y, m - 1 + delta, 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

/**
 * First month allowed as a projection column: strictly after the last month with data
 * and strictly after the current calendar month (next month earliest).
 */
export function firstProjectionMonth(lastDataMonth: string): string {
  const afterLast = bumpMonth(lastDataMonth, 1)
  const afterCurrentCalendar = bumpMonth(currentYm(), 1)
  return afterLast > afterCurrentCalendar ? afterLast : afterCurrentCalendar
}

/** Consecutive projection month keys starting from {@link firstProjectionMonth}. */
export function getProjectionMonthKeys(lastDataMonth: string, count: number): string[] {
  let m = firstProjectionMonth(lastDataMonth)
  const out: string[] = []
  for (let i = 0; i < count; i++) {
    out.push(m)
    m = bumpMonth(m, 1)
  }
  return out
}
